import { render, staticRenderFns } from "./franProvince.vue?vue&type=template&id=0cb27ccc&scoped=true&"
import script from "./franProvince.vue?vue&type=script&lang=js&"
export * from "./franProvince.vue?vue&type=script&lang=js&"
import style0 from "./franProvince.vue?vue&type=style&index=0&lang=css&"
import style1 from "./franProvince.vue?vue&type=style&index=1&id=0cb27ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb27ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb27ccc')) {
      api.createRecord('0cb27ccc', component.options)
    } else {
      api.reload('0cb27ccc', component.options)
    }
    module.hot.accept("./franProvince.vue?vue&type=template&id=0cb27ccc&scoped=true&", function () {
      api.rerender('0cb27ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/franProvince.vue"
export default component.exports